import { Archetype } from "./archetype.js"
import { ENTITY_TYPE_CHARACTER }  from './constants.js'
import { Utilities } from "./utilities.js"


let nextNumber = 1

export class Character {
    constructor(options) {
        // console.info('character.js - constructing')
        if(options.number) {
            this.number = options.number
        } else {
            this.number = nextNumber
            nextNumber++
        }

        if(options.isAdversary) {
            this.isAdversary = true
        } else {
            this.isAdversary = false
        }

        this.entityType = ENTITY_TYPE_CHARACTER
        this.health = options.health ? options.health : Utilities.d(10)
        this.maxHealth = this.health

        if (options.archetype) {
            this.archetype = options.archetype
        } else {
            const roll = Utilities.d(100)
            if(roll > 40) {
                this.archetype = Archetype.meleeDps(this.isAdversary)
            } else {
                this.archetype = Archetype.rangedDps(this.isAdversary)
            }
        }
        
        this.position = options.position ? options.position : {x:0,y:0}

        this.name = options.name ? options.name : `Character ${this.number}`
    }

    takeDamage = (damage) => {
        this.health -= damage
    }

    isAlive() {
        return this.health > 0
    }




    obfuscatedHealth() {
        const damageAsPercent = this.health / this.maxHealth
        if ( damageAsPercent <= 0) {
            return 'DEAD'
        } else if( damageAsPercent < 0.25) {
            return 'NEAR DEATH'
        } else if( damageAsPercent < 0.4) {
            return 'BADLY HURT'
        } else if( damageAsPercent < 0.7) {
            return 'LIGHTLY WOUNDED'
        }

        return 'HEALTHY'
    }

}